// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WYEAx57noM_AZY {
  height: 28px;
  padding: var(--ds-space-100, 8px) var(--ds-space-050, 4px) var(--ds-space-050, 4px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
`, ""]);
// Exports
export var listSubscribeIcon = `WYEAx57noM_AZY`;
export default ___CSS_LOADER_EXPORT___;
